import request from '@/utils/request'
import type { CartVo, Cart } from '@/types/cart'

// 查询购物车列表
export const getCartList = (userId: number) => {
  return request.get<CartVo[]>(`/cart/list?userId=${userId}`)
}

// 保存（添加/更新）购物车
export const saveCart = (data: Cart) => {
  return request.post<void>('/cart/save', data)
}
